import * as Headless from '@headlessui/react'
import NextLink, { type LinkProps } from 'next/link'
import { forwardRef } from 'react'

export const Link = forwardRef(function Link(
  props: LinkProps & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <Headless.DataInteractive>
      <NextLink ref={ref} {...props} />
    </Headless.DataInteractive>
  )
})

export type SimpleLink = {
  href: string
  label: string
  external: boolean
  primary?: boolean
}

export type FlyoutLink = SimpleLink & {
  flyout: {
    href: string
    label: string
    description: string
    external: boolean
    flag?: string
  }[]
}

export type GroupedLinks = {
  title: string
  links: SimpleLink[] | FlyoutLink[] | (SimpleLink & FlyoutLink[])
}
